import { NgFor,NgIf } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  ControlValueAccessor,
  FormArray,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  ValidationErrors,
  Validator} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { ChainFocusDirective } from './chain-focus.directive';
import { ChainFocusItemDirective } from './chain-focus-item.directive';

@UntilDestroy()
@Component({
  selector: 'app-chain-input',
  templateUrl: './chain-input.component.html',
  styleUrls: ['./chain-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChainInputComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ChainInputComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [NgIf, ChainFocusDirective, ReactiveFormsModule, NgFor,
    MatFormFieldModule, MatInputModule, ChainFocusItemDirective]
})
export class ChainInputComponent implements OnInit, OnChanges, ControlValueAccessor, Validator {
  constructor() {}

  @Output() completeEnter = new EventEmitter();
  @Input() length: number = 4;
  @Input() clearForm: boolean = false;

  formArray: FormArray = new FormArray<any>([]);
  isDisabled: boolean = false;

  ngOnInit(): void {
    this.prepareFormArray(this.length);
    this.formArray.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      const formValue = this.formArray.value.join('');

      this.onChange(formValue);

      if (formValue.length === this.length) {
        this.completeEnter.emit();
      }
    });
  }

  ngOnChanges(): void {
    if (this.clearForm) {
      this.formArray.controls.forEach(item => {
        item.setValue('');
      });
    }
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(): void {
  }

  registerOnValidatorChange(): void {
  }

  validate(): ValidationErrors | null {
    return null;
  }

  private prepareFormArray(length: number): void {
    this.formArray.clear();
    for (let i = 0; i < length; i++) {
      this.formArray.push(new FormControl());
    }
  }
}
